
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

export const catalogImportTranslations: any =  TranslationBlueprint.make({
      name: 'catalog-import-pt-BR',
      
      params: {
          resource: createTranslationResource({
              ref: catalogImportTranslationRef,
              translations: {
                  'pt-BR': () => import('./catalog-import-ptbr'),
              },
          }),
      },
  });